export interface TokenValidationResponse {
    validationResultType: TokenValidationResultType;
}

export enum TokenValidationResultType {
    NoMatchingInviteFound = 0,

    InvitationIsStillValid = 1,

    TokenAlreadySuccessfullyCreatedUser = 2,

    TokenLikelyReplacedWithNewToken = 3
}